import { render, staticRenderFns } from "./StudentQuizWrapper.vue?vue&type=template&id=8189842e"
import script from "./StudentQuizWrapper.vue?vue&type=script&lang=js"
export * from "./StudentQuizWrapper.vue?vue&type=script&lang=js"
import style0 from "./StudentQuizWrapper.vue?vue&type=style&index=0&id=8189842e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports